import { memo } from 'react';

import styles from './Disclaimer.module.scss';

interface DisclaimerProps {
  plural?: boolean;
  isCut?: boolean;
}

function Disclaimer({ plural, isCut }: DisclaimerProps) {
  if (isCut) {
    return (
      <p className={styles.disclaimer}>
        <span>
          This DiLog Cut report is based on the diamond geometry only and does not include any laboratory grading data of a real stone. To compare diamonds of
          similar geometry online, visit{' '}
        </span>

        <a href="https://cutwise.com" target="_blank">
          CUTWISE.COM
        </a>

        <span>.</span>
      </p>
    );
  }

  return (
    <p className={styles.disclaimer}>
      <span>These DiLog </span>

      <span>report{plural ? 's are ' : ' is '}</span>

      <span>
        not appraisals and do not carry valuations. Data of Color, Clarity, Material, Floresence etc are derived either from the Lab Certificates or Client may
        have provided to Cutwise. To Compare your Diamond with other Diamonds of similar grades we advise you to check it online on{' '}
      </span>

      <a href="https://cutwise.com" target="_blank">
        CUTWISE.COM
      </a>

      <span>.</span>
    </p>
  );
}

export default memo(Disclaimer);
